import React from "react";
import { connect } from "react-redux";
import { BannerListContainerStyled /* StatusButton */ } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
// import * as XLSX from "xlsx";
// import moment from "moment";
import momentTZ from "moment-timezone";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { IMG_PATH } from "utils/constants/imgPath";
import { portalService } from "apiServices";
// import {
//   BOOKING_STATUS_OPTIONS,
//   RENDER_BOOKING_STATUS,
//   RENDER_VISITOR_STATUS,
// } from "utils/functions/booking";
// import { DIVISION_OPTIONS } from "utils/functions/division";
// import { INSTUMENT_TYPE_OPTIONS } from "utils/functions/productBooking";
// import { RENDER_CHARACTER_REPLACE_BY_PERMISSION } from "utils/functions/string";
import { Buttons, Displays, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class BannerListContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (query) => {
    let res = await portalService.GET_BANNER_LIST(query);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
          total: res.data.totalDocs,
          per_page: res.data.limit,
        },
        isLoading: false,
      });
    }
  };

  // handleFilterKeyword = (e) => {
  //   const { perPage } = this.state;
  //   this.setState({
  //     filterQuery: e,
  //   });
  //   this.handleJoinQuery(e, perPage, 1);
  // };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoading: true,
    });
    this.props.router.navigate(`${ROUTE_PATH.FRONTEND_SETTING_BANNER}${joinQuery}`);
    this.fetchData(joinQuery);
  };

  handleClickNext = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.FRONTEND_SETTING_BANNER}/${e}`);
  };

  render() {
    const { authenRedux } = this.props;
    const { isLoading, pagination, data } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "frontend_setting");
    return (
      <BannerListContainerStyled>
        {permission && permission.is_create && (
          <div className="btn_create">
            <div className="w120">
              <Buttons.BgIconPrefix
                label="Add"
                onClick={() => this.handleClickNext("create")}
              />
            </div>
          </div>
        )}
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <div className="body_table">
            <Tables.Standard
              columns={columns({
                handleClickDetail: this.handleClickNext,
              })}
              data={data}
              showPagination
              pagination={pagination}
              handlePageClick={this.handlePageClick}
              onChangePerPage={this.handlePerPageChange}
            />
          </div>
        )}
      </BannerListContainerStyled>
    );
  }
}

const columns = ({ handleClickDetail }) => [
  {
    Header: <div style={{ textAlign: "left" }}>ลำดับการแสดงผล</div>,
    accessor: "sequence",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value ?? "-"}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Preview</div>,
    accessor: "img_path",
    Cell: (props) =>
      props.value ? (
        <Zoom>
          <img
            className="banner_preview_img"
            alt="banner preview"
            src={IMG_PATH + props.value}
          />
        </Zoom>
      ) : (
        <div onClick={() => handleClickDetail(props.row.original._id)}>-</div>
      ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Create</div>,
    accessor: "created_at",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Active</div>,
    accessor: "is_active",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value ? (
          <Displays.StatusLabel bg={"green"} label={"ทำงาน"} />
        ) : (
          <Displays.StatusLabel bg={"#FFB341CC"} label={"ไม่ทำงาน"} />
        )}
      </div>
    ),
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BannerListContainer));
